import { playIncomingCallRingtone, stopIncomingCallRingtone } from './sound';

export class TabAlertManager {
  private originalTitle: string = typeof document !== 'undefined' ? document.title : 'Medikei';
  private titleBlinkInterval: ReturnType<typeof setInterval> | null = null;
  private isAlerting: boolean = false;
  private onVisibilityChangeHandler: (() => void) | null = null;

  /**
   * Inicia o alerta na aba quando uma chamada for recebida e a aba estiver em segundo plano.
   */
  startAlert(alertMessage = '🔴 NOVA CHAMADA!') {
    if (typeof document === 'undefined') return;
    if (this.isAlerting) return;

    this.isAlerting = true;
    this.originalTitle = document.title;

    // Alternância do título da aba
    let toggle = false;
    this.titleBlinkInterval = setInterval(() => {
      document.title = toggle ? alertMessage : this.originalTitle;
      toggle = !toggle;
    }, 1000);

    // Toca o áudio contínuo sintetizado
    try {
      playIncomingCallRingtone();
    } catch (err) {
      console.warn('[TabAlertManager] Erro ao iniciar ringtone sintético:', err);
    }

    // Ouvinte para restaurar título e interromper alertas sonoros ao focar na janela
    this.onVisibilityChangeHandler = () => {
      if (!document.hidden) {
        this.stopTitleBlinkOnly();
      }
    };

    document.addEventListener('visibilitychange', this.onVisibilityChangeHandler);
    window.addEventListener('focus', this.onVisibilityChangeHandler);
  }

  /**
   * Interrompe apenas o piscar do título (mantendo o som se ainda estiver aguardando ação).
   */
  private stopTitleBlinkOnly() {
    if (this.titleBlinkInterval) {
      clearInterval(this.titleBlinkInterval);
      this.titleBlinkInterval = null;
    }
    if (typeof document !== 'undefined' && this.originalTitle) {
      document.title = this.originalTitle;
    }
  }

  /**
   * Interrompe todos os alertas (visual e sonoro).
   */
  stopAlert() {
    this.isAlerting = false;
    this.stopTitleBlinkOnly();

    try {
      stopIncomingCallRingtone();
    } catch (err) {
      console.warn('[TabAlertManager] Erro ao parar ringtone:', err);
    }

    if (this.onVisibilityChangeHandler && typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.onVisibilityChangeHandler);
      window.removeEventListener('focus', this.onVisibilityChangeHandler);
      this.onVisibilityChangeHandler = null;
    }
  }

  isActive(): boolean {
    return this.isAlerting;
  }
}

export const tabAlertManager = new TabAlertManager();
